// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trapezoid{height:0;width:360px;border-bottom:200px solid hsla(0,0%,100%,.5607843137254902);border-left:15px solid hsla(0,0%,100%,.5607843137254902);border-right:80px solid transparent}", ""]);
// Exports
module.exports = exports;
